import DisplayFilesPreview from './DisplayFilesPreview.component';

export default DisplayFilesPreview;